import * as Yup from "yup";

export const requireValidateion: Yup.StringSchema = Yup.string().required("必須項目です。");
export const emailValidateion: Yup.StringSchema = Yup.string().required("必須項目です。").email("emailの形式になっていません。").max(200, "200文字以上の文字が入力されています。");
export const passwordValidateion: Yup.StringSchema = Yup.string().required("必須項目です。").min(8, "文字数は8文字以上20字以下です。").max(20, "文字数は8文字以上20字以下です。").matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9.?/\-_!]+$/, { message: "パスワードに使用可能な文字列は、英数字と一部記号[.?/-_!]のみとなり、英数字を1文字以上含める必要があります。" });
export const userNameValidation: Yup.StringSchema = Yup.string().required("必須項目です。").max(20, "文字数は20字以下です。");
export const licenseQuantityValidation: Yup.NumberSchema = Yup.number().required("必須項目です").min(1).max(999);
export const PostCodeValidation: Yup.StringSchema = Yup.string().required("必須項目です。").matches(/^\d{7,7}$/, { message: "郵便番号は7桁の数値です。" });
export const AddressValidation: Yup.StringSchema = Yup.string().required("必須項目です。").min(1, "文字数は1文字以上256字以下です。").max(256, "文字数は1文字以上256字以下です。");
export const CustomerNameValidation: Yup.StringSchema = Yup.string().required("必須項目です。").min(1, "文字数は1文字以上256字以下です。").max(256, "文字数は1文字以上256字以下です。");
export const PhoneNumberValidation: Yup.StringSchema = Yup.string().required("必須項目です。").matches(/^\d{1,11}$/, { message: "電話番号は11桁の数値です。" });
export const BikoValidation: Yup.StringSchema = Yup.string().min(0, "文字数は0文字以上256字以下です。").max(256, "文字数は0文字以上256字以下です。");
export const ReciptAtenaValidation: Yup.StringSchema = Yup.string().required("宛名：必須項目です。").max(20, "宛名：21字以上の文字が入力されています。");

export const QuantityValidation = (minValue: number, maxValue: number): Yup.NumberSchema => {
    return Yup.number().required("必須項目です").min(minValue, `指定できる値は${minValue}～${maxValue}です。`).typeError("数値を入力してください。");
}

export type ErrorDetail = {
    errorMessage: string,
    propertyName: string
}

/**
 * サーバでのバリデーションの結果
 * */
export type ValidateMessage = {
    isValid: boolean,
    errorDetailList: ErrorDetail[]
}